// Shared helpers for the Brand Share stacked-bar views (National / Intensity / Loyalty).
import { PALETTE } from './theme';

const OTHERS_COLOR = '#9ca3af'; // muted grey for the rolled-up "Others" segment

// Last N months (default 6) ending at selectedMonth, from the full month list.
export function last6(allMonths, selectedMonth, n = 6) {
  const idx = allMonths.indexOf(selectedMonth);
  if (idx < 0) return allMonths.slice(-n);
  return allMonths.slice(Math.max(0, idx - (n - 1)), idx + 1);
}

// Build stacked-bar series from long-format rows.
// Keeps the top-`n` apps by total sessions across the window; the rest roll into "Others".
// Returns [{ name, data: number[] aligned to months6, color }].
export function topNplusOthers(rows, months6, { valueKey, appKey = 'application', n = 8 } = {}) {
  if (!rows?.length) return [];

  // Total sessions per app across the visible window → rank
  const totals = {};
  rows.forEach(r => {
    if (!months6.includes(r.month_id)) return;
    totals[r[appKey]] = (totals[r[appKey]] || 0) + (+r[valueKey] || 0);
  });
  const ranked  = Object.keys(totals).sort((a, b) => totals[b] - totals[a]);
  const topApps = ranked.slice(0, n);
  const topSet  = new Set(topApps);
  const hasOthers = ranked.length > n;

  // month -> app -> value
  const byMonthApp = {};
  rows.forEach(r => {
    if (!months6.includes(r.month_id)) return;
    (byMonthApp[r.month_id] = byMonthApp[r.month_id] || {});
    const bucket = topSet.has(r[appKey]) ? r[appKey] : '__others__';
    byMonthApp[r.month_id][bucket] = (byMonthApp[r.month_id][bucket] || 0) + (+r[valueKey] || 0);
  });

  const series = topApps.map((app, i) => ({
    name:  app,
    data:  months6.map(m => byMonthApp[m]?.[app] ?? 0),
    color: PALETTE[i % PALETTE.length],
  }));
  if (hasOthers) {
    series.push({
      name:  'Others',
      data:  months6.map(m => byMonthApp[m]?.['__others__'] ?? 0),
      color: OTHERS_COLOR,
    });
  }
  return series;
}
